import * as React from 'react';

import { cn } from 'utils/shadcn';

import Manhattan from '../assets/manhattan-logo.png';

export default function ManhattanLogo(
  props: React.ImgHTMLAttributes<HTMLImageElement>
): React.JSX.Element {
  const { className: classNameProp, ...otherProps } = props;

  return (
    <img
      src={Manhattan}
      alt='Manhattan logo'
      className={cn('filter brightness-80 scale-125', classNameProp)}
      {...otherProps}
    />
  );
}
